export const GET_ALL_PROJECT = 'GET_ALL_PROJECT'
export const GET_ALL_SUCCESS_PROJECT = 'GET_ALL_SUCCESS_PROJECT'
export const GET_ALL_ERROR_PROJECT = 'GET_ALL_ERROR_PROJECT'

export const GET_PROJECT_SVC = 'GET_PROJECT_SVC'
export const GET_SUCCESS_PROJECT_SVC = 'GET_SUCCESS_PROJECT_SVC'
export const GET_ERROR_PROJECT_SVC = 'GET_ERROR_PROJECT_SVC'
